
















































































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST } from "../global";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";
@Component({
  name: "HistoryBlock",
})
export default class HistoryBlock extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  showAnim: boolean = false;
  showHistory: boolean = false;
  current = 0;
  itemClick(index: any) {
    if ((this as any).current == index) {
      (this as any).current = 0;
      (this as any).showAnim = true;
    } else {
      (this as any).current = index;
      // (this as any).showCounter = true;
    }
  }
  historyScroll() {
    let d: any = document;
    let scrollpos = window.scrollY;
    const elem = d.querySelector(".history-container");
    const counterlist = window.scrollY + window.innerHeight;
    const isHalfshown = counterlist > elem.offsetTop;
    const countbottom = elem.offsetTop + elem.height;
    const isNotscrolledPast = window.scrollY < countbottom;
    if (isHalfshown) {
      (this as any).showHistory = true;
    }
  }
  created() {
    window.addEventListener("scroll", this.historyScroll);
  }
  destroyed() {
    window.removeEventListener("scroll", this.historyScroll);
  }

  //   public mounted() {
  //     if (window.matchMedia("(min-width: 1025px)").matches) {
  //    //  this.hisAnim();

  //     }
  //   }
}
